module.exports = __webpack_public_path__ + "files/bba7a1b3f62e02f410a88472b03fce70.png";